import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Pagination } from 'react-bootstrap';
import moment from 'moment-timezone';
import { TIMEZONE } from '../../helpers/argenitianTimeZone';
import { notify } from 'react-notify-toast';
import { deleteCoupon } from '../../services/couponService';

const FORMATDATE = 'DD-MM-YYYY';

const CouponRow = ({ coupon, onDelete }) => {
  const handleDeleteClick = () => onDelete(coupon.couponCode);
  return (
    <tr className="text-center">
      <td>{coupon?.beneficiaryEmail ? coupon?.beneficiaryEmail : '-'}</td>
      <td>
        {coupon?.beneficiaryId?.name && coupon.beneficiaryId?.surname
          ? coupon?.beneficiaryId?.name + ' ' + coupon?.beneficiaryId?.surname
          : '-'}
      </td>
      <td className="text-wrap">{coupon?.comments ? coupon?.comments : '-'}</td>
      <td>{coupon?.amountToDiscount}</td>
      <td>{moment(coupon?.createdAt).tz(TIMEZONE).format(FORMATDATE)}</td>
      <td>{coupon?.couponCode}</td>
      <td>{coupon?.claimByEmail || coupon?.claimById ? 'Si' : 'No'}</td>
      <td>
        <div className="d-flex justify-content-center">
          <button
            onClick={handleDeleteClick}
            className="ml-2 text-danger"
            aria-label="Delete Coupon"
            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
          >
            <i className="far fa-trash-alt" />
          </button>
        </div>
      </td>
    </tr>
  );
};
const PageItem = ({ page, currentPage, onPageChange }) => {
  const handleClick = () => onPageChange(page);
  return (
    <Pagination.Item active={page === currentPage} onClick={handleClick}>
      {page}
    </Pagination.Item>
  );
};

const CouponsAssigned = ({ coupons, pagination, onPageChange }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedCouponCode, setSelectedCouponCode] = useState(null);
  const [localCoupons, setLocalCoupons] = useState(coupons);

  useEffect(() => {
    setLocalCoupons(coupons);
  }, [coupons]);

  const handleShowDeleteModal = (couponCode) => {
    setSelectedCouponCode(couponCode);
    setShowDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedCouponCode(null);
  };

  const handleConfirmDelete = async (couponCode) => {
    try {
      await deleteCoupon(couponCode);
      notify.show('Cupón eliminado correctamente', 'success');
      setLocalCoupons((prev) =>
        prev.filter((coupon) => coupon.couponCode !== couponCode)
      );
      setShowDeleteModal(false);
    } catch (err) {
      console.error('Error al eliminar el cupón', err);
      notify.show('Error al eliminar el cupón', 'error');
    }
  };

  const handleDeleteSelected = () => handleConfirmDelete(selectedCouponCode);

  const { currentPage, totalPages, hasNextPage, totalRecords } = pagination;

  const handleFirstPage = () => onPageChange(1);
  const handlePrevPage = () => onPageChange(currentPage - 1);
  const handleNextPage = () => onPageChange(currentPage + 1);
  const handleLastPage = () => onPageChange(totalPages);

  return (
    <div className="mt-5">
      <Table striped bordered hover variant="dark">
        <thead className="text-center">
          <tr>
            <th>Email</th>
            <th>Nombre y Apellido</th>
            <th>Descripción</th>
            <th>% de descuento</th>
            <th>Fecha de creación</th>
            <th>Código de Cupon</th>
            <th>Canjeado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(localCoupons) && localCoupons.map((coupon) => (
            <CouponRow key={coupon._id} coupon={coupon} onDelete={handleShowDeleteModal} />
          ))}
        </tbody>
      </Table>

      {totalRecords > 0 && (
        <div className="d-flex justify-content-between align-items-center">
          <span className="text-muted">
            Página {currentPage} de {totalPages} ({totalRecords} cupones)
          </span>
          <Pagination>
            <Pagination.First onClick={handleFirstPage} disabled={currentPage === 1} />
            <Pagination.Prev onClick={handlePrevPage} disabled={currentPage === 1} />
            {Array.from({ length: totalPages }, (_, i) => (
              <PageItem key={i + 1} page={i + 1} currentPage={currentPage} onPageChange={onPageChange} />
            ))}
            <Pagination.Next onClick={handleNextPage} disabled={!hasNextPage} />
            <Pagination.Last onClick={handleLastPage} disabled={currentPage === totalPages} />
          </Pagination>
        </div>
      )}

      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Estás seguro que deseas eliminar este cupón?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteModal}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDeleteSelected}>
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default CouponsAssigned;
